const packs_btns = document.querySelectorAll(".pack_box");
const selectedFixedProducts = document.querySelector(".selected-fixed-products");
const productCards = document.querySelectorAll(".builder_product_card");

const updateSelectedFixedProducts = (count) => {
  const stickyElement = document.querySelector(".selected-fixed-container");
  const existingElements = document.querySelectorAll(".selected-fixed-el");
  const currentCount = existingElements.length;
  let plusBtns = document.querySelectorAll('button[data-action="plus"]');

  stickyElement.classList.remove("atc-btn-active");

  if (currentCount < count) {
    for (let i = currentCount; i < count; i++) {
      const el = document.createElement("div");
      el.classList.add("selected-fixed-el");
      selectedFixedProducts.appendChild(el);
    }
    plusBtns.forEach((btn) => {
      btn.removeAttribute("disabled");
    });
  } else if (currentCount > count) {
    selectedFixedProducts.innerHTML = "";
    for (let i = 0; i < count; i++) {
      const el = document.createElement("div");
      el.classList.add("selected-fixed-el");
      selectedFixedProducts.appendChild(el);
    }

    document.querySelectorAll(".builder_product_card").forEach((el) => {
      if (
        !document.querySelector(
          `.selected-fixed-el[data-id="${el.dataset.product_id}"]`
        )
      ) {
        el.querySelector(".builder_selected_qty").innerHTML = "0";
        el.querySelector(".builder_qty_selector").dataset.qty = "0";
        el
          .querySelector('.builder_qty_selector button[data-action="minus"]')
          .setAttribute("disabled", true);
        el
          .querySelector('.builder_qty_selector button[data-action="plus"]')
          .removeAttribute("disabled");
      }
    });
  }
};

function attributesHandler() {
  productCards.forEach((card) => {
    card.setAttribute("data-quantity-text", "0");
    card.setAttribute("data-quantity", "0");
  });
}

let previousPackSize = 6; // default initial pack size

packs_btns.forEach((btn) => {
  btn.addEventListener("click", () => {
    // Update active pack button
    packs_btns.forEach((btn) => btn.classList.remove("pack_box-active"));
    btn.classList.add("pack_box-active");

    const newPackSize = parseInt(btn.dataset.available_packs, 10);

    // If switching to smaller pack, reset
    if (newPackSize < previousPackSize ) {
      productCards.forEach((card) => {
        card.setAttribute("data-quantity", "0");
        card.setAttribute("data-quantity-text", "0");

        const qtySelector = card.querySelector(".builder_qty_selector");
        qtySelector.dataset.qty = "0";
        qtySelector.querySelector(".builder_selected_qty").textContent = "0";
        qtySelector.querySelector('button[data-action="minus"]').setAttribute("disabled", true);
      });
    }

    previousPackSize = newPackSize;
    // ✅ Show cookie counter on pack click
    showCookieCounter();
    showMobileCounter();

    // Recalculate button logic and summary
    updateQtyActions(document.querySelector(".builder_qty_selector button[data-action='plus']"), 0);
    updateSummarySidebar();
    updateBlurredCards(); // ✅ Add here after updateSummarySidebar()

  });
});


/* A/B Test */
const packs_cards = document.querySelectorAll(".pack_card");

const updateActivePackCard = (card) => {
  const btn = document.querySelector('.btn-add-cookies');

  if (card.dataset.autoVariant) {
    document.querySelectorAll('.packs_selector_wrapper_v2 .pack_card').forEach(c => c.classList.remove("pack_card-active"));
    card.classList.add('pack_card-active');
    
    btn.querySelector('.button--text').innerText = btn.dataset.labelAddToCart;

    return;
  }

  btn.querySelector('.button--text').innerText = btn.dataset.labelAddCookies;

  const newPackSize = parseInt(card.dataset.available_packs, 10);
  previousPackSize = newPackSize;

  document.querySelectorAll('.pack-card-group').forEach(group => {
    group.querySelectorAll('.pack_card').forEach(c => c.classList.toggle("pack_card-active", c.dataset.available_packs == newPackSize));
  });

  // ✅ Show cookie counter on pack click
  showCookieCounter();
  showMobileCounter();

  // Recalculate button logic and summary
  updateQtyActions(document.querySelector(".builder_qty_selector button[data-action='plus']"), 0);
  updateSummarySidebar();
  updateBlurredCards(); // ✅ Add here after updateSummarySidebar()
};

packs_cards.forEach((card) => {
  card.addEventListener("click", () => {
    updateActivePackCard(card);
  });
});

const changeQty = (button) => {
  const action = button.getAttribute("data-action");
  const qtyDisplay = button
    .closest(".builder_product_card")
    .querySelector(".builder_selected_qty");

  let currentQty = parseInt(qtyDisplay.textContent.match(/\d+/)[0]) || 0;
  const minusBtn = button
    .closest(".builder_qty_selector")
    .querySelector('button[data-action="minus"]');

  const availablePack = parseInt(document.querySelector(getPackBoxSelector())?.dataset.available_packs || 0);
  const qtySelectors = document.querySelectorAll(".builder_qty_selector");

  let totalQty = 0;
  qtySelectors.forEach((el) => {
    totalQty += parseInt(el.getAttribute("data-qty")) || 0;
  });

  // STOP adding if limit reached
  if (action === "plus" && totalQty >= availablePack) return;

  // Update quantity
  if (action === "minus" && currentQty > 0) {
    currentQty -= 1;
  } else if (action === "plus") {
    currentQty += 1;
  }

  // Update quantity display
  qtyDisplay.textContent = `${currentQty}`;
  const productCard = qtyDisplay.closest(".builder_product_card");
  const qtySelector = button.closest(".builder_qty_selector");

  if (qtySelector) qtySelector.dataset.qty = currentQty;
  if (productCard) {
    productCard.setAttribute("data-quantity", currentQty);
    productCard.setAttribute("data-quantity-text", `${currentQty}`);
  }

  // Toggle minus button
  if (currentQty > 0) {
    minusBtn.removeAttribute("disabled");
  } else {
    minusBtn.setAttribute("disabled", true);
  }

  // Hide qty buttons if zero
  const addBtn = button.closest(".builder_qty_wrapper")?.querySelector('.add-btn');
  if (currentQty === 0) {
    //qtySelector?.classList.add('hidden');
    //addBtn?.classList.remove('hidden');
  }

  updateSelectedEl(
    productCard?.querySelector("img"),
    action,
    productCard?.dataset.product_id,
    productCard?.dataset.productTitle
  );

  updateQtyActions(button, currentQty);
  updateSummarySidebar();
  
  // ✅ Show header if user interacts and qty > 0
  if (totalQty + (action === "plus" ? 1 : -1) > 0) {
    showCookieCounter();
    showMobileCounter();

  };
  updateBlurredCards();
};

/* for button code add in product block 

const changeQty = (button) => {
  const action = button.getAttribute("data-action");
  const qtyDisplay = button
    .closest(".builder_product_card")
    .querySelector(".builder_selected_qty");

  let currentQty = parseInt(qtyDisplay.textContent.match(/\d+/)[0]);
  let minusBtn = button
    .closest(".builder_qty_selector")
    .querySelector('button[data-action="minus"]');

  if (action === "minus" && currentQty > 0) {
    currentQty -= 1;
    updateQtyActions(button, currentQty, action);
  } else if (action === "plus") {
    currentQty += 1;
    updateQtyActions(button, currentQty, action);
  }

  if (currentQty > 0) {
    minusBtn.removeAttribute("disabled");
  } else {
    minusBtn.setAttribute("disabled", true);
  }
const addBtn = button.closest('.builder_qty_wrapper').querySelector('.add-btn');
const qtyWrapper = button.closest('.builder_qty_wrapper');





if (currentQty === 0) {
  // Switch back to ADD button
  qtyWrapper.querySelector('.builder_qty_selector').classList.add('hidden');
  addBtn.classList.remove('hidden');
}

  qtyDisplay.textContent = `${currentQty}`;
  const productCard = qtyDisplay.closest(".builder_product_card");
  if (productCard) {
    productCard.setAttribute("data-quantity", currentQty);
    productCard.setAttribute("data-quantity-text", `${currentQty}`);
  }

  updateSelectedEl(
    button.closest(".builder_product_card").querySelector("img"),
    action,
    button.closest(".builder_product_card").dataset.product_id,
    button.closest(".builder_product_card").dataset.productTitle
  );
  updateSummarySidebar();
};



function onAddFirst(button) {
  const card = button.closest('.builder_product_card');
  const qtyWrapper = card.querySelector('.builder_qty_wrapper');
  const qtySelector = card.querySelector('.builder_qty_selector');
  const qtyDisplay = card.querySelector('.builder_selected_qty');
  const plusBtn = qtySelector.querySelector('button[data-action="plus"]');

  // Switch view
  button.classList.add('hidden');
  qtySelector.classList.remove('hidden');

  // Set initial qty to 1
  qtySelector.dataset.qty = '1';
  qtyDisplay.textContent = '1';
  card.dataset.quantity = '1';
  card.dataset.quantityText = '1';

  plusBtn.removeAttribute("disabled");
  qtySelector.querySelector('button[data-action="minus"]').removeAttribute("disabled");

  // Update fixed product summary and quantity logic
  updateQtyActions(plusBtn, 1, 'plus');

  const img = card.querySelector('img');
  const productId = card.dataset.product_id;
  const title = card.dataset.productTitle;

  updateSelectedEl(img, 'plus', productId, title);
   updateSummarySidebar(); 
};

*/
function updateBlurredCards() {
  const cards = document.querySelectorAll(".builder_product_card");
  const availablePack = parseInt(document.querySelector(getPackBoxSelector())?.dataset.available_packs || "6", 10);

  let totalQty = 0;
  cards.forEach((card) => {
    const qty = parseInt(card.dataset.quantity || "0", 10);
    totalQty += qty;
    card.classList.remove("blurred"); // ✅ Always reset first
  });

  // ✅ Re-apply blur only if pack is full
  if (totalQty >= availablePack) {
    cards.forEach((card) => {
      const qty = parseInt(card.dataset.quantity || "0", 10);
      if (qty === 0) {
        card.classList.add("blurred");
      }
    });
  }
};



const updateQtyActions = (button, currentQty, action) => {
  const qtySelectors = document.querySelectorAll(".builder_qty_selector");
  const available_packs = +document.querySelector(getPackBoxSelector()).dataset.available_packs;
  let plusBtns = document.querySelectorAll('button[data-action="plus"]');
  const addToCartBtn = document.querySelector(".atc-btn");

  let totalQty = 0;
  qtySelectors.forEach((el) => {
    const qty = parseInt(el.dataset.qty || "0", 10);
    totalQty += qty;
  });

  // Update per-quantity selector
  if (button?.closest) {
    button.closest(".builder_qty_selector").dataset.qty = currentQty;
  }

  if (totalQty === available_packs) {
    plusBtns.forEach((btn) => btn.setAttribute("disabled", true));
    addToCartBtn.classList.remove("atc-btn-disabled");
  } else {
    plusBtns.forEach((btn) => btn.removeAttribute("disabled"));
    addToCartBtn.classList.add("atc-btn-disabled");
  }
};

function updateSummarySidebar() {
  const summaryItemsWrapper = document.getElementById("summaryItems");
  const cookieCounter = document.getElementById("cookieCounter");
  const cookieLimit = document.getElementById("cookieLimit");

  const summaryItemsMobile = document.getElementById("summaryItemsMobile");
  const cookieCounterMobile = document.getElementById("cookieCounterMobile");
  const cookieLimitMobile = document.getElementById("cookieLimitMobile");

  summaryItemsWrapper.innerHTML = "";
  summaryItemsMobile.innerHTML = "";

  const allCards = document.querySelectorAll(".builder_product_card");
  let total = 0;
  let limit = parseInt(document.querySelector(getPackBoxSelector())?.dataset.available_packs || 6);

  allCards.forEach((card) => {
    const qty = parseInt(card.dataset.quantity || 0);
    if (qty > 0) {
      const title = card.dataset.productTitle;
      const id = card.dataset.product_id;

      const row = document.createElement("div");
      row.classList.add("summary-item");
      row.setAttribute("data-id", id);
      const pieceLabel = qty > 1 ? window.BUILDER_TRANSLATIONS.pieces : window.BUILDER_TRANSLATIONS.piece;

row.innerHTML = `
  <button onclick="removeFromSummary('${id}')"><svg width="24" height="28" viewBox="0 0 24 28" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="1.125" y="3.125" width="21.75" height="21.75" rx="10.875" fill="white" fill-opacity="0.01"/>
<rect x="1.125" y="3.125" width="21.75" height="21.75" rx="10.875" stroke="#3C3433" stroke-width="2.25"/>
<path d="M14.3531 10.0813L16.0077 11.736L13.6785 14.0652L16.0077 16.3944L14.3531 18.049L12.0239 15.7198L9.68193 18.0618L8.0273 16.4071L10.3692 14.0652L7.95117 11.6471L9.60581 9.99249L12.0239 12.4106L14.3531 10.0813Z" fill="#3C3433"/>
</svg>
</button>
  <span>${title}</span>
  <span>${qty} ${pieceLabel}</span>
`;

      summaryItemsWrapper.appendChild(row);
      summaryItemsMobile.appendChild(row.cloneNode(true));

      total += qty;
    }
    
  });

  cookieCounter.textContent = total;
  cookieLimit.textContent = limit;
  cookieCounterMobile.textContent = total;
  cookieLimitMobile.textContent = limit;
  //code for pop up counter info box
  const popupCounter = document.getElementById("popupCookieCounter");
  const popupLimit = document.getElementById("popupCookieLimit");

  if (popupCounter && popupLimit) {
    popupCounter.textContent = total;
    popupLimit.textContent = limit;
  }
  //code end for the popup counter

  // Toggle ATC button state for both desktop & mobile
  const addToCartBtn = document.querySelector(".atc-btn");
  const addToCartBtnMobile = document.querySelector(".atc-btn-mobile");

  if (total === limit) {
    addToCartBtn?.classList.remove("atc-btn-disabled");
    addToCartBtnMobile?.classList.remove("atc-btn-disabled");
  } else {
    addToCartBtn?.classList.add("atc-btn-disabled");
    addToCartBtnMobile?.classList.add("atc-btn-disabled");
  }

  /* A/B Test - Variation */
  if (isVariationB()) {
    updateSummarySidebarV2();
  }
};

/* A/B Test - Variation */
function updateSummarySidebarV2() {
  const summaryItemsMobile = document.getElementById("summaryItemsMobileV2");
  const cookieCounterMobile = document.getElementById("cookieCounterMobileV2");
  const cookieLimitMobile = document.getElementById("cookieLimitMobileV2");

  summaryItemsMobile.innerHTML = "";

  const allCards = document.querySelectorAll(".builder_product_card");
  let total = 0;
  let limit = parseInt(document.querySelector(".pack_card-active")?.dataset.available_packs || 6);

  allCards.forEach((card) => {
    const qty = parseInt(card.dataset.quantity || 0);
    if (qty > 0) {
      const title = card.dataset.productTitle;
      const id = card.dataset.product_id;

      const row = document.createElement("div");
      row.classList.add("summary-item");
      row.setAttribute("data-id", id);
      const pieceLabel = qty > 1 ? window.BUILDER_TRANSLATIONS.pieces : window.BUILDER_TRANSLATIONS.piece;

row.innerHTML = `
  <button onclick="removeFromSummary('${id}')"><svg width="24" height="28" viewBox="0 0 24 28" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="1.125" y="3.125" width="21.75" height="21.75" rx="10.875" fill="white" fill-opacity="0.01"/>
<rect x="1.125" y="3.125" width="21.75" height="21.75" rx="10.875" stroke="#3C3433" stroke-width="2.25"/>
<path d="M14.3531 10.0813L16.0077 11.736L13.6785 14.0652L16.0077 16.3944L14.3531 18.049L12.0239 15.7198L9.68193 18.0618L8.0273 16.4071L10.3692 14.0652L7.95117 11.6471L9.60581 9.99249L12.0239 12.4106L14.3531 10.0813Z" fill="#3C3433"/>
</svg>
</button>
  <span>${title}</span>
  <span>${qty} ${pieceLabel}</span>
`;

      summaryItemsMobile.appendChild(row);

      total += qty;
    }
  });

  cookieCounterMobile.textContent = total;
  cookieLimitMobile.textContent = limit;
  //code for pop up counter info box
  const popupCounter = document.getElementById("popupCookieCounter");
  const popupLimit = document.getElementById("popupCookieLimit");

  if (popupCounter && popupLimit) {
    popupCounter.textContent = total;
    popupLimit.textContent = limit;
  }
  //code end for the popup counter

  // Toggle ATC button state for both desktop & mobile
  const addToCartBtnMobile = document.querySelector(".atc-btn-v2");

  if (total === limit) {
    addToCartBtnMobile?.classList.remove("atc-btn-disabled");
  } else {
    addToCartBtnMobile?.classList.add("atc-btn-disabled");
  }
};


const updateSelectedEl = (img, action, product_id, title) => {
  const selectedEls = document.querySelectorAll(".selected-fixed-el");

  if (action === "plus") {
    const imgClone = img.cloneNode(true);
    for (let el of selectedEls) {
      if (!el.querySelector("img")) {
        el.dataset.id = product_id;
        el.dataset.product_title = title;
        el.appendChild(imgClone);
        break;
      }
    }
  } else if (action === "minus") {
    let foundIndex = -1;
    for (let i = 0; i < selectedEls.length; i++) {
      const currentImg = selectedEls[i].querySelector("img");
      if (
        currentImg &&
        currentImg.src.split("/").pop() === img.src.split("/").pop()
      ) {
        selectedEls[i].removeAttribute("data-id");
        selectedEls[i].removeAttribute("data-product_title");
        selectedEls[i].removeChild(currentImg);
        foundIndex = i;
        break;
      }
    }
    if (foundIndex !== -1) {
      for (let i = foundIndex; i < selectedEls.length - 1; i++) {
        const nextImg = selectedEls[i + 1].querySelector("img");
        const nextDataId = selectedEls[i + 1].dataset.id;
        const nextProductTitle = selectedEls[i + 1].dataset.product_title;

        if (nextImg) {
          selectedEls[i].appendChild(nextImg.cloneNode(true));
          selectedEls[i + 1].removeChild(nextImg);
          selectedEls[i].dataset.id = nextDataId;
          selectedEls[i].dataset.product_title = nextProductTitle;
          selectedEls[i + 1].removeAttribute("data-id");
          selectedEls[i + 1].removeAttribute("data-product_title");
        }
      }
    }
  }
};

const productInput = document.querySelector(
  ".product-buy-buttons--input-builder"
);
const bundleItemProperties = document.getElementById("bundle_item_properties");
const buttonSubmitForm = document.querySelector(
  ".product-buy-buttons--primary-builder"
);

document.querySelector('.btn-add-cookies').addEventListener('click', function() {
  const activeCard = document.querySelector('.packs_selector_wrapper_v2 .pack_card-active');
  if (activeCard.dataset.autoVariant) {
    if (bundleItemProperties) {
      bundleItemProperties.value = '';
    }
    if (productInput) {
      productInput.value = activeCard.dataset.autoVariant;
    }

    this.setAttribute('aria-busy', true);


    /* If there is not found a free gift line item in the cart drawer, just add hidden elements to the product form */
    /*
    let cart = document.querySelector('cart-element');
    let freeGiftItem = false; 

    if (cart.getAttribute('data-has-items') != 'false') {
      freeGiftItem = document.querySelector('.cart--item[data-is-gift="true"]');
    }

    let form = document.querySelector('.product-page--form');
    if (freeGiftItem) {
      // Already there.
      document.body.appendChild(document.querySelector('.free-gift-elements'));
    } else {
      // Not found in the cart. Add to the cart together
      form.appendChild(document.querySelector('.free-gift-elements'));
    }
    */

    buttonSubmitForm?.click();

    setTimeout(() => {
      this.setAttribute('aria-busy', false);
    }, 2000);

    return false;
  }

  document.querySelector('.btn-add-cookies').style.display = 'none';
  document.querySelector('.btn-step-back').style.display = 'block';
  document.querySelector('.atc-btn-v2').style.display = 'block';

  document.body.setAttribute('data-builder-step', 2);
  document.querySelector('.nav-step-2').classList.add('complete');
});

document.querySelector('.btn-step-back').addEventListener('click', function() {
  document.querySelector('.btn-step-back').style.display = 'none';
  document.querySelector('.atc-btn-v2').style.display = 'none';
  document.querySelector('.btn-add-cookies').style.display = 'block';

  document.body.setAttribute('data-builder-step', 1);
  document.querySelector('.nav-step-2').classList.remove('complete');
});

document.querySelectorAll(".atc-btn").forEach((btn) => {
  btn.addEventListener("click", () => {
    if (btn.classList.contains("atc-btn-disabled")) return;

    setTimeout(() => {
      const flavorCount = {};
      const allCards = document.querySelectorAll(".builder_product_card");

      allCards.forEach((card) => {
        const qty = parseInt(card.dataset.quantity || 0);
        if (qty > 0) {
          const handle = card.dataset.product_handle;
          const title = card.dataset.productTitle;
          if (!flavorCount[handle]) {
            flavorCount[handle] = { title, quantity: 0 };
          }
          flavorCount[handle].quantity += qty;
        }
      });

      const readableParts = Object.entries(flavorCount).map(
        ([_, obj]) => `${obj.title} - ${obj.quantity}x`
      );
      const readableString = readableParts.join(", ");
      console.log("User-friendly text:", readableString);

      const selectedBundleVariantID = document.querySelector(getPackBoxSelector())?.dataset.bundle_product;
      if (!selectedBundleVariantID) {
        console.warn("No selected bundle variant ID found.");
        return;
      }

      if (bundleItemProperties) {
        bundleItemProperties.value = readableString;
      }
      if (productInput) {
        productInput.value = selectedBundleVariantID;
      }

      /* If there is not found a free gift line item in the cart drawer, just add hidden elements to the product form */
      /*
      let cart = document.querySelector('cart-element');
      let freeGiftItem = false; 

      if (cart.getAttribute('data-has-items') != 'false') {
        freeGiftItem = document.querySelector('.cart--item[data-is-gift="true"]');
      }

      let form = document.querySelector('.product-page--form');
      if (freeGiftItem) {
        // Already there.
        document.body.appendChild(document.querySelector('.free-gift-elements'));
      } else {
        // Not found in the cart. Add to the cart together
        form.appendChild(document.querySelector('.free-gift-elements'));
      }
      */

      buttonSubmitForm?.click();


      if (isVariationB()) {
        btn.setAttribute('aria-busy', true);

        window.location.href = '/checkout';
        return false;
      }

      // Optional: Open cart drawer
      document.dispatchEvent(new CustomEvent("cart:refresh"));
    }, 0);
  });
});

/* To prevent showing loading indicator when coming back from checkout */
window.addEventListener('pageshow', function (event) {
  document.querySelectorAll('[aria-busy="true"]').forEach(btn => {
    btn.setAttribute('aria-busy', false);
  });
});

function imagesHandler(image, wrapper) {
  const slide = document.createElement("div");
  slide.classList.add("swiper-slide");

  slide.innerHTML = `<img src="${image}" loading="lazy" alt="Builder product image" />`;
  wrapper.appendChild(slide);
}

const overlayContainer = document.querySelector(".builder-popup-container");
const clearBLocks = document.querySelectorAll(".clear-in-js");
const popupClose = document.querySelector(".builder-popup-close");
const popupAddButton = document.querySelector(".popup-add-to-box");

let mainSwiper;
let secondarySwiper;

function buttonDisabledHandler(mainButton, popupButton) {
  if (mainButton.disabled) {
    popupButton.setAttribute("disabled", "true");
  } else {
    popupButton.removeAttribute("disabled");
  }
}

// VALUE-BASED VIDEO METHOD JAVASCRIPT
// FINAL PRODUCTION VERSION - Clean, working video popup
document.querySelectorAll(".builder_product_info, .info-icon").forEach((el) => {
  el.addEventListener("click", () => {
    const productCard = el.closest(".builder_product_card");

    if (productCard) {
      const description = productCard.dataset.productDescription;
      const images = productCard.dataset.productImages ? productCard.dataset.productImages.split(",") : [];
      const additionalImage = productCard.dataset.productAdditionalImage;
      const productVideoHtml = productCard.dataset.productVideoHtml;
      const productVideoSources = productCard.dataset.productVideoSources;
      const title = productCard.dataset.productTitle;

      const minusButton = productCard.querySelector('.builder_qty_selector button[data-action="minus"]');
      const plusButton = productCard.querySelector('.builder_qty_selector button[data-action="plus"]');

      const descriptionWrapper = document.querySelector(".description");
      const titleWrapper = document.querySelector(".title");
      const mainImagesWrapper = document.querySelector(".builder-swiper .swiper-wrapper");
      const secondaryImagesWrapper = document.querySelector(".swiper-additional-builder .swiper-wrapper");
      const thumbnailContainer = document.querySelector(".swiper-additional-builder");

      // Clear previous content
      if (mainImagesWrapper) mainImagesWrapper.innerHTML = '';
      if (secondaryImagesWrapper) secondaryImagesWrapper.innerHTML = '';

      // Update text content
      if (descriptionWrapper) descriptionWrapper.innerHTML = description;
      if (titleWrapper) titleWrapper.innerText = title;

      if (popupAddButton) {
        popupAddButton.setAttribute("data-product-id", productCard.getAttribute("data-product_id"));
        buttonDisabledHandler(plusButton, popupAddButton);
      }

      // Collect unique media items
      let allMedia = [];
      let usedUrls = new Set();
      
      // Add main images (no duplicates)
      images.forEach((image) => {
        const cleanUrl = image.trim();
        if (cleanUrl && cleanUrl !== '' && !usedUrls.has(cleanUrl)) {
          usedUrls.add(cleanUrl);
          allMedia.push({ src: cleanUrl, type: 'image' });
        }
      });
      
      // Add additional image
      if (additionalImage && additionalImage.trim() && additionalImage.trim() !== '') {
        const cleanUrl = additionalImage.trim();
        if (!usedUrls.has(cleanUrl)) {
          usedUrls.add(cleanUrl);
          allMedia.push({ src: cleanUrl, type: 'image' });
        }
      }
      
      // Add video using Shopify .value method
      if (productVideoHtml && productVideoHtml.trim() && productVideoHtml.includes('<video')) {
        allMedia.push({ src: productVideoHtml.trim(), type: 'shopify_video' });
      } else if (productVideoSources && productVideoSources.trim()) {
        const sourceUrls = productVideoSources.split('|').filter(url => url.trim());
        if (sourceUrls.length > 0) {
          let videoHtml = '<video controls style="width:100%; height:100%; object-fit:cover;">';
          sourceUrls.forEach(url => {
            videoHtml += `<source src="${url.trim()}" type="video/mp4">`;
          });
          videoHtml += 'Your browser does not support the video tag.</video>';
          allMedia.push({ src: videoHtml, type: 'custom_video' });
        }
      }

      // Populate main swiper
      allMedia.forEach((media) => {
        const mainSlide = document.createElement("div");
        mainSlide.classList.add("swiper-slide");
        
        if (media.type === 'shopify_video' || media.type === 'custom_video') {
          mainSlide.innerHTML = media.src;
        } else {
          mainSlide.innerHTML = `<img src="${media.src}" loading="lazy" alt="Product media" style="width:100%; height:100%; object-fit:cover;" />`;
        }
        mainImagesWrapper.appendChild(mainSlide);
      });

      // Show thumbnails only if multiple media items
      if (allMedia.length > 1) {
        thumbnailContainer.style.display = 'block';
        
        allMedia.forEach((media) => {
          const thumbSlide = document.createElement("div");
          thumbSlide.classList.add("swiper-slide");
          
          if (media.type === 'shopify_video' || media.type === 'custom_video') {
            thumbSlide.classList.add("video-thumbnail");
            
            // Create a temporary video element to extract the first frame
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = media.src;
            const videoElement = tempDiv.querySelector('video');
            
            if (videoElement) {
              // Clone the video element for thumbnail
              const thumbVideo = videoElement.cloneNode(true);
              thumbVideo.muted = true;
              thumbVideo.controls = false;
              thumbVideo.style.cssText = 'width:100%; height:100%; object-fit:cover; pointer-events:none;';
              thumbVideo.preload = 'metadata';
              thumbVideo.currentTime = 1; // Show frame at 1 second
              
              // Create container with play overlay
              thumbSlide.innerHTML = `
                <div style="position: relative; width: 100%; height: 100%; overflow: hidden; border-radius: 4px;">
                  ${thumbVideo.outerHTML}
                  <div style="
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                    background: rgba(0, 0, 0, 0.7);
                    color: white;
                    border-radius: 50%;
                    width: 24px;
                    height: 24px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 12px;
                    pointer-events: none;
                  ">▶</div>
                  <div style="
                    position: absolute;
                    bottom: 2px;
                    right: 2px;
                    background: rgba(0, 0, 0, 0.8);
                    color: white;
                    padding: 1px 4px;
                    border-radius: 2px;
                    font-size: 8px;
                    font-weight: bold;
                  ">VIDEO</div>
                </div>
              `;
            } else {
              // Fallback to icon if video element can't be created
              thumbSlide.innerHTML = `
                <div style="
                  width:100%; 
                  height:100%; 
                  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
                  display:flex; 
                  align-items:center; 
                  justify-content:center; 
                  color:white; 
                  font-size:18px; 
                  position:relative; 
                  border-radius:4px;
                ">
                  ▶
                  <div style="
                    position:absolute; 
                    bottom:3px; 
                    right:3px; 
                    background:rgba(0,0,0,0.8); 
                    color:white; 
                    padding:2px 5px; 
                    border-radius:3px; 
                    font-size:8px;
                    font-weight:bold;
                  ">VIDEO</div>
                </div>
              `;
            }
          } else {
            thumbSlide.innerHTML = `<img src="${media.src}" loading="lazy" alt="Thumbnail" style="width:100%; height:100%; object-fit:cover;" />`;
          }
          secondaryImagesWrapper.appendChild(thumbSlide);
        });
      } else {
        thumbnailContainer.style.display = 'none';
      }

      // Initialize swipers
      setTimeout(() => {
        if (window.secondarySwiper) window.secondarySwiper.destroy(true, true);
        if (window.mainSwiper) window.mainSwiper.destroy(true, true);

        if (allMedia.length > 1) {
          window.secondarySwiper = new Swiper(".swiper-additional-builder", {
            slidesPerView: 'auto',
            spaceBetween: 10,
            freeMode: true,
            watchSlidesProgress: true,
          });

          window.mainSwiper = new Swiper(".builder-swiper", {
            slidesPerView: 1,
            speed: 600,
            thumbs: {
              swiper: window.secondarySwiper
            },
            on: {
              slideChange: function () {
                const videos = document.querySelectorAll('.builder-swiper video');
                videos.forEach(video => video.pause());
              }
            }
          });
        } else {
          window.mainSwiper = new Swiper(".builder-swiper", {
            slidesPerView: 1,
            speed: 600
          });
        }
      }, 100);

      // Show popup
      document.querySelector(".builder-popup-overlay").classList.add("builder-popup-overlay-active");
      document.body.classList.add("overflow");
    }
  });
});



// Adds one of the popup's product to the box via the card's own plus button,
// then closes the popup if the add went through (it won't when the box is full).
popupAddButton?.addEventListener("click", () => {
  const productCard = document.querySelector(
    `.builder_product_card[data-product_id="${popupAddButton.getAttribute("data-product-id")}"]`
  );
  const plusButton = productCard?.querySelector('.builder_qty_selector [data-action="plus"]');
  if (!plusButton || plusButton.disabled) return;

  const previousQty = productCard.dataset.quantity;
  plusButton.click();

  if (productCard.dataset.quantity !== previousQty) {
    popupCloseHandler();
  } else {
    buttonDisabledHandler(plusButton, popupAddButton);
  }
});

function popupCloseHandler() {
  const videos = document.querySelectorAll('.builder-popup-container video');
  videos.forEach(video => {
    video.pause();
    video.currentTime = 0;
  });

  document.querySelector(".builder-popup-overlay").classList.remove("builder-popup-overlay-active");
  document.body.classList.remove("overflow");
  
  const clearBlocks = document.querySelectorAll(".clear-in-js");
  clearBlocks.forEach((block) => {
    block.innerHTML = "";
  });
  
  if (window.mainSwiper) {
    window.mainSwiper.destroy(true, true);
    window.mainSwiper = null;
  }
  if (window.secondarySwiper) {
    window.secondarySwiper.destroy(true, true);
    window.secondarySwiper = null;
  }
}

document
  .querySelector(".builder-popup-overlay")
  .addEventListener("click", (e) => {
    if (e.target.classList.contains("builder-popup-overlay")) {
      popupCloseHandler();
    }
  });

popupClose.addEventListener("click", () => {
  popupCloseHandler();
});

function removeFromSummary(productId) {
  const card = document.querySelector(`.builder_product_card[data-product_id="${productId}"]`);
  if (!card) return;

  // ✅ 1. Reset quantity in left product card
  card.dataset.quantity = "0";
  card.dataset.quantityText = "0";

  const qtySelector = card.querySelector(".builder_qty_selector");
  qtySelector.dataset.qty = "0";
  qtySelector.querySelector(".builder_selected_qty").textContent = "0";
  qtySelector.querySelector('button[data-action="minus"]').setAttribute("disabled", true);

  // ❌ Do NOT hide quantity UI or show "Add" button again
  // card.querySelector(".add-btn").classList.remove("hidden");
  // qtySelector.classList.add("hidden");

  // ✅ 2. Remove from .selected-fixed-products (used for bundle logic)
  const selectedEls = document.querySelectorAll(".selected-fixed-products .selected-fixed-el");
  selectedEls.forEach((el) => {
    if (el.dataset.id === productId) {
      el.innerHTML = "";
      el.removeAttribute("data-id");
      el.removeAttribute("data-product_title");
    }
  });

  // ✅ 3. Remove row from right-side summary list (mobile/desktop)
  document.querySelectorAll(".summary-item").forEach((row) => {
    if (row.dataset.id === productId) row.remove();
  });

  // ✅ 4. Recalculate sidebar + ATC availability
  updateSummarySidebar();

  // ✅ 5. Rebuild Add to Cart data
  const selectedElsActive = document.querySelectorAll(".selected-fixed-products [data-id]");
  const flavorCount = {};

  selectedElsActive.forEach((el) => {
    const flavorId = el.dataset.id;
    const linkedCard = document.querySelector(`.builder_product_card[data-product_id="${flavorId}"]`);
    if (!linkedCard) return;

    const handle = linkedCard.dataset.product_handle;
    const title = linkedCard.dataset.productTitle;
    const qty = parseInt(linkedCard.dataset.quantity || "0");

    if (qty > 0) {
      if (!flavorCount[handle]) {
        flavorCount[handle] = { title, quantity: 0 };
      }
      flavorCount[handle].quantity += qty;
    }
  });

  const readableParts = Object.entries(flavorCount).map(([handle, obj]) => {
    return `${obj.title} - ${obj.quantity}x`;
  });

  const readableString = readableParts.join(", ");
  document.getElementById("bundle_item_properties").value = readableString;


  const pack_box_selector = getPackBoxSelector();
  const selectedBundleVariantID = document.querySelector(pack_box_selector)?.dataset.bundle_product;
  document.querySelector(".product-buy-buttons--input-builder").value = selectedBundleVariantID;

    // ✅ 6. Re-enable "+" buttons if under pack limit
  const qtySelectors = document.querySelectorAll(".builder_qty_selector");
  const plusBtns = document.querySelectorAll('button[data-action="plus"]');
  let totalQty = 0;

  qtySelectors.forEach((el) => {
    totalQty += parseInt(el.dataset.qty) || 0;
  });

  const availablePack = parseInt(document.querySelector(pack_box_selector)?.dataset.available_packs || 0);

  if (totalQty < availablePack) {
    plusBtns.forEach((btn) => btn.removeAttribute("disabled"));
  }

  updateBlurredCards();

}




document.addEventListener("DOMContentLoaded", () => {
  const atcBtns = document.querySelectorAll(".atc-btn, .atc-btn-mobile");
  atcBtns.forEach((btn) => {
    if (document.body.dataset.builderStep == 1 && btn.classList.contains("atc-btn-v2")) {
      // Skip
    } else {
      btn.classList.add("atc-btn-disabled");
    }
  });
  
  const atcBtnMobile = document.querySelector(".atc-btn-mobile");
  atcBtnMobile?.classList.add("atc-btn-disabled");
});

 
document.addEventListener("DOMContentLoaded", () => {
  const toggleBtn = document.getElementById("summaryToggle");
  const itemsBox = document.getElementById("summaryItemsMobile");
  const arrow = document.getElementById("summaryArrow");
  itemsBox?.classList.add("collapsed");
    arrow?.classList.remove("rotated");
  toggleBtn?.addEventListener("click", () => {
    const isCollapsed = itemsBox.classList.toggle("collapsed");
    arrow.classList.toggle("rotated", !isCollapsed);
  });
});


/* A/B Test - Variation */
document.addEventListener("DOMContentLoaded", () => {
  const toggleBtn = document.getElementById("summaryToggleV2");
  const accordionContent = document.getElementById("summaryAccordionContentV2");
  const arrow = document.getElementById("summaryArrowV2");
  accordionContent?.classList.add("collapsed");
    arrow?.classList.remove("rotated");
  toggleBtn?.addEventListener("click", () => {
    const isCollapsed = accordionContent.classList.toggle("collapsed");
    arrow.classList.toggle("rotated", !isCollapsed);
  });
});


//for hiding the cookies box message 
function showCookieCounter() {
  document.querySelector(".builder-summary__empty-state")?.classList.add("hidden");
  document.querySelector(".builder-summary__header")?.classList.remove("hidden");
}

function showMobileCounter() {
  document.querySelectorAll('.empty-state-text-mobile').forEach(el => el.classList.add('hidden'));
  document.querySelectorAll('.cookie-counter-text-mobile').forEach(el => el.classList.remove('hidden'));
}



// ============================================
// BUILDER PRODUCT PRESELECTION SYSTEM
// ============================================

(function() {
  'use strict';

  const CONFIG = {
    preselectDelay: 800,
    clickInterval: 200,
    highlightDuration: 2000,
    scrollBehavior: 'smooth',
    autoScroll: true
  };

  function getUrlParameter(param) {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(param);
  }

  function findProductCard(handle) {
    return document.querySelector(`[data-product_handle="${handle}"]`);
  }

  function clickMultipleTimes(button, times) {
    for (let i = 0; i < times; i++) {
      setTimeout(() => {
        if (button && !button.disabled) {
          button.click();
        }
      }, i * CONFIG.clickInterval);
    }
  }

  function highlightProduct(card) {
    card.classList.add('preselected-highlight');
    setTimeout(() => {
      card.classList.remove('preselected-highlight');
    }, CONFIG.highlightDuration);
  }

  function scrollToProduct(card) {
    if (CONFIG.autoScroll) {
      setTimeout(() => {
        card.scrollIntoView({ 
          behavior: CONFIG.scrollBehavior, 
          block: 'center' 
        });
      }, 300);
    }
  }

  function preselectProduct(handle, quantity = 1) {
    const productCard = findProductCard(handle.trim());
    
    if (!productCard) {
      console.warn(`Product with handle "${handle}" not found in builder`);
      return;
    }

    const plusButton = productCard.querySelector('[data-action="plus"]');
    
    if (!plusButton) {
      console.warn(`Plus button not found for product "${handle}"`);
      return;
    }

    clickMultipleTimes(plusButton, quantity);
    highlightProduct(productCard);
    scrollToProduct(productCard);

    console.log(`✓ Preselected: ${handle} (${quantity}x)`);
  }

  function parsePreselectParam(param) {
    if (!param) return [];
    
    return param.split(',').map(item => {
      const [handle, qty] = item.trim().split(':');
      return {
        handle: handle,
        quantity: parseInt(qty) || 1
      };
    });
  }

  function initPreselection() {
    const preselectParam = getUrlParameter('preselect');
    
    if (!preselectParam) return;

    const products = parsePreselectParam(preselectParam);
    
    if (products.length === 0) return;

    console.log('🍪 Builder Preselection Active:', products);

    setTimeout(() => {
      products.forEach((product, index) => {
        setTimeout(() => {
          preselectProduct(product.handle, product.quantity);
        }, index * (CONFIG.clickInterval * 3));
      });
    }, CONFIG.preselectDelay);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPreselection);
  } else {
    initPreselection();
  }

  window.builderPreselect = {
    init: initPreselection,
    preselect: preselectProduct,
    config: CONFIG
  };

})();